import { useRef, useState, useSyncExternalStore } from 'react';
import { onlineManager, useQuery } from '@tanstack/react-query';
import type { FullSyncPreview } from '@/shared/api';

export function useFullSyncPreview(
  propertyId: string,
  loadPreview: () => Promise<FullSyncPreview>,
) {
  const [ready, setReady] = useState(false);
  const request = useRef(0);
  const isOnline = useSyncExternalStore(
    (onStoreChange) => onlineManager.subscribe(onStoreChange),
    () => onlineManager.isOnline(),
    () => true,
  );
  const query = useQuery({
    queryKey: ['channex', 'fullSyncPreview', propertyId],
    queryFn: loadPreview,
    enabled: false,
  });

  const refresh = async () => {
    const currentRequest = ++request.current;
    setReady(false);
    const result = await query.refetch();
    if (currentRequest === request.current && result.isSuccess && !result.isPaused) {
      setReady(true);
    }
  };

  const reset = () => {
    request.current += 1;
    setReady(false);
  };

  return { query, ready, isOnline, refresh, reset };
}
